export class IdGenerator {
  private static counter = 0;

  generateId(): string {
    const newCounter = ++IdGenerator.counter;
    return `incrementedId-${newCounter}`;
  }
}
